import { Button, Flex, Text } from 'components/elements'
import { NetworkError } from 'components/icons/NetworkError'

const NetworkErrorPage = () => {
  const handleRefresh = () => {
    window.location.reload()
  }
  return (
    <>
      <Flex
        direction={'column'}
        align={'center'}
        justify={'center'}
        css={{
          background: '$white100',
          width: '100vw',
          borderRadius: '$rounded',
          height: '100vh',
        }}
      >
        <NetworkError />
        <Flex direction={'column'} align={'center'}>
          <Text as="h4" css={{ mt: '$space$32' }}>
            Network Connection Error
          </Text>
          <Text as="p" css={{ mt: '$space$16' }}>
            It looks like your internet is a bit unstable. Please check your
            connection and try again.
          </Text>
          <Button css={{ mt: '$space$28' }} onClick={handleRefresh}>
            Refresh Page
          </Button>
        </Flex>
      </Flex>
    </>
  )
}

export default NetworkErrorPage
